import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatIconModule } from '@angular/material/icon';
import { DgEnvironmentDetailsComponent } from './dg-environment-details/dg-environment-details.component';
@NgModule({
  declarations: [DgEnvironmentDetailsComponent],
  imports: [CommonModule, MatIconModule],
  exports: [DgEnvironmentDetailsComponent],
})
export class DgSharedModule {}
